import { makeStyles } from "@mui/styles";
import { fonts } from "../../theme/fonts";
import { colors } from "../../theme/colors";
const { text } = fonts;
const { Grey, Base } = colors;

export default makeStyles({
  title: {
    ...text.lg.medium,
    color: Grey[900],
    margin: 0,
    marginBottom: 16,
    textAlign: "center",
    overflowWrap: "anywhere",
  },
  xlTitle: {
    ...text.xl.medium,
    color: Grey[900],
  },
  modalBody: {
    ...text.sm.normal,
    color: Grey[500],
    marginBottom: "24px",
    minWidth: 0,
    maxWidth: "100%",
    overflowWrap: "anywhere",
  },
  modalCloseButton: {
    gridColumn: 3,
    gridRow: 1,
    justifySelf: "end",
    alignSelf: "start",
    width: 36,
    height: 36,
    borderRadius: "8px",
    backgroundColor: Grey[100],
    "&:hover": {
      backgroundColor: Grey[200],
    },
  },
  modalActions: {
    minWidth: 0,
    "& > .MuiButtonBase-root": {
      flex: "1 1 0",
      minWidth: 0,
      whiteSpace: "normal",
    },
  },
  modalHeader: {
    display: "grid",
    gridTemplateColumns: "40px minmax(0, 1fr) 40px",
    alignItems: "center",
    padding: "16px 16px 8px",
  },
  modalContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    minWidth: 0,
    maxWidth: "calc(100vw - 32px)",
    maxHeight: "calc(100vh - 32px)",
    overflowY: "auto",
    overflowX: "hidden",
    boxSizing: "border-box",
    backgroundColor: Base.White,
    boxShadow: "0px 24px 48px rgba(22, 31, 37, 0.18)",
    borderRadius: "12px",
  },
  contentContainer: {
    padding: "8px 24px 24px",
    minWidth: 0,
    "& > form": {
      minWidth: 0,
      width: "100%",
    },
    "@media (max-width: 599px)": {
      padding: "8px 16px 16px",
    },
  },
});
